import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { IconTheme } from '@rd/types/icon-theme.type';

type AlertTheme = 'primary' | 'warn' | 'transparent' | 'success' | 'error';

@Component({
  selector: 'rd-shared-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedAlertComponent {
  @HostBinding('class.rd-shared-alert') componentClass = true;

  @HostBinding('class.alert-primary') get isAlertPrimary(): boolean {
    return this.alertTheme === 'primary';
  }

  @HostBinding('class.alert-success') get isAlertSuccess(): boolean {
    return this.alertTheme === 'success';
  }

  @HostBinding('class.alert-warn') get isAlertWarn(): boolean {
    return this.alertTheme === 'warn';
  }

  @HostBinding('class.alert-transparent') get isAlertTransparent(): boolean {
    return this.alertTheme === 'transparent';
  }

  @HostBinding('class.alert-error') get isAlertError(): boolean {
    return this.alertTheme === 'error';
  }

  @Input() icon?: string;
  @Input() iconTheme: IconTheme = 'primary';
  @Input() alertTheme: AlertTheme = 'primary';
  @Input() class?: string = '';
}
